import { useQueryClient as c, useMutation as y, useQuery as w } from "@tanstack/react-query";
import s from "./newlane-tutorials.api.js";
import { teachurKeys as l } from "../../constants/teachurKeys.js";
const q = (e) => w({
  queryKey: l.newlaneTutorials.list(),
  queryFn: async () => (await s.getAll()).data,
  ...e
}), d = (e, u) => w({
  queryKey: l.newlaneTutorials.detail(e),
  queryFn: async () => (await s.getOne(e)).data,
  enabled: !!e && e !== -1,
  ...u
}), Q = (e) => {
  const u = c();
  return y({
    mutationFn: async (a) => (await s.remove(a)).data,
    onSuccess: (a, r, t) => {
      var n;
      u.invalidateQueries({ queryKey: l.newlaneTutorials.all }), (n = e == null ? void 0 : e.onSuccess) == null || n.call(e, a, r, t);
    },
    ...e
  });
}, K = (e) => {
  const u = c();
  return y({
    mutationFn: async (a) => (await s.create(a)).data,
    onSuccess: (a, r, t) => {
      var n;
      u.invalidateQueries({ queryKey: l.newlaneTutorials.all }), (n = e == null ? void 0 : e.onSuccess) == null || n.call(e, a, r, t);
    },
    ...e
  });
}, S = (e) => {
  const u = c();
  return y({
    mutationFn: async ({ id: a, ...r }) => (await s.update(a, r)).data,
    onSuccess: (a, r, t) => {
      var n;
      u.invalidateQueries({ queryKey: l.newlaneTutorials.all }), (n = e == null ? void 0 : e.onSuccess) == null || n.call(e, a, r, t);
    },
    ...e
  });
};
export {
  K as useCreateNewlaneTutorialMutation,
  Q as useDeleteNewlaneTutorialMutation,
  d as useGetNewlaneTutorialQuery,
  q as useGetNewlaneTutorialsQuery,
  S as useUpdateNewlaneTutorialMutation
};
